import { useTranslation } from "react-i18next";
import { Divider } from "@/components/common/divider";
import { useAPIUsersAvatar } from "@/hooks/use-api-users-avatar";
import { useAPIUserProfile } from "@/hooks/use-api-user-profile";
import { iamAccountHooks, iamAccountManager } from "@/manager";
import { AvatarUpload } from "./avatar-upload";
import { NameForm } from "./name-form";
import EmailForm from "./email-form";
import { LanguageForm } from "./language-form";

function Head() {
  const { t } = useTranslation();
  return (
    <h1 className="mb-4 text-2xl font-semibold text-i-normal">
      {t("settings_account.index.account")}
    </h1>
  );
}

export function SettingsAccount() {
  const { account } = iamAccountHooks.useData();
  const { handleAPIUsersAvatar } = useAPIUsersAvatar();
  const { handleAPIUserProfile } = useAPIUserProfile();

  const handleChange = async (firstName: string, lastName: string) => {
    const fullName = `${firstName} ${lastName}`.trim();
    try {
      await handleAPIUserProfile({
        username: fullName,
      });
      iamAccountManager.update({
        ...iamAccountManager.get(),
        username: fullName,
      });
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleUpload = async (blob: Blob) => {
    await handleAPIUsersAvatar({
      avatar: new File([blob], "avatar.png", { type: "image/png" }),
    });
    iamAccountManager.update({
      ...iamAccountManager.get(),
      avatar: URL.createObjectURL(blob),
    });
  };

  if (!account) {
    return null;
  }
  return (
    <div className="p-8 max-w-[800px]">
      <Head />
      <AvatarUpload
        avatar={account.avatar}
        title={account.username}
        onUpload={handleUpload}
      />
      <Divider />
      <NameForm
        firstName={account.username?.split(" ")[0]}
        lastName={account.username?.split(" ")[1]}
        onChange={handleChange}
      />
      <Divider />
      <EmailForm email={account.email} />
      <Divider />
      <LanguageForm />
    </div>
  );
}
